exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".text-price{font-size:.85em}.disable-option{opacity:.4}.v-dialog{overflow:inherit!important}", ""]);

// exports
